import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 8px 32px;
`;
